import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";


class DatiAnagraficiMalaria extends React.Component {

    state = {
        datiAnagrafici: {
            cognome: "",
            nome: "",
            dataNascita: "",
            eta: "",
            sesso: "",
            indirizzo: "",
            comune: "",
            provincia: "",
            professione: "",
            cittadinanza: "",
            corretto: []
        },
        listaComuni: Utils.distinctComuni(JSON.parse(sessionStorage.getItem("comuni")), new Date()),
        listaProvince: JSON.parse(sessionStorage.getItem("province")),
        listaNazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
        provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice"))

    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        let datiAnagrafici = this.state.datiAnagrafici
        let professioni = OggettiUtili.Professioni

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMalaria) {

            let datiAnagraficiProps = this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiMalaria

            datiAnagrafici.cognome = datiAnagraficiProps.cognome ? datiAnagraficiProps.cognome : this.state.datiAnagrafici.cognome
            datiAnagrafici.nome = datiAnagraficiProps.nome ? datiAnagraficiProps.nome : this.state.datiAnagrafici.nome
            datiAnagrafici.dataNascita = datiAnagraficiProps.dataNascita ? datiAnagraficiProps.dataNascita : this.state.datiAnagrafici.dataNascita
            datiAnagrafici.eta = datiAnagraficiProps.eta || datiAnagraficiProps.eta === 0 ? datiAnagraficiProps.eta : this.state.datiAnagrafici.eta
            datiAnagrafici.sesso = datiAnagraficiProps.sesso ? datiAnagraficiProps.sesso : this.state.datiAnagrafici.sesso
            datiAnagrafici.indirizzo = datiAnagraficiProps.indirizzo ? datiAnagraficiProps.indirizzo : this.state.datiAnagrafici.indirizzo
            datiAnagrafici.comune = datiAnagraficiProps.comune ? datiAnagraficiProps.comune : this.state.nazioniPerCodice[datiAnagraficiProps.comune] ? this.state.nazioniPerCodice[datiAnagraficiProps.comune] : this.state.datiAnagrafici.comune
            datiAnagrafici.provincia = datiAnagraficiProps.provincia ? datiAnagraficiProps.provincia : this.state.datiAnagrafici.provincia
            datiAnagrafici.professione = datiAnagraficiProps.professione ? datiAnagraficiProps.professione : this.state.datiAnagrafici.professione
            datiAnagrafici.cittadinanza = datiAnagraficiProps.cittadinanza ? datiAnagraficiProps.cittadinanza : this.state.datiAnagrafici.cittadinanza

            this.setState({datiAnagrafici: datiAnagrafici});
        } else if (this.props.datiPaziente) {

            let datiPazienteProps = this.props.datiPaziente

            datiAnagrafici.nome = datiPazienteProps.nomePaziente ? datiPazienteProps.nomePaziente : ""
            datiAnagrafici.cognome = datiPazienteProps.cognomePaziente ? datiPazienteProps.cognomePaziente : ""
            datiAnagrafici.dataNascita = datiPazienteProps.dataDiNascita ? datiPazienteProps.dataDiNascita : ""
            datiAnagrafici.eta = datiPazienteProps.eta ? datiPazienteProps.eta : ""
            datiAnagrafici.sesso = datiPazienteProps.sesso ? datiPazienteProps.sesso : ""
            datiAnagrafici.indirizzo = datiPazienteProps.indirizzoDomicilio ? datiPazienteProps.indirizzoDomicilio : ""
            datiAnagrafici.provincia = datiPazienteProps.provinciaResidenza && datiPazienteProps.provinciaResidenza.codice && this.state.provincePerCodice[datiPazienteProps.provinciaResidenza.codice] ? this.state.provincePerCodice[datiPazienteProps.provinciaResidenza.codice] : ""
            datiAnagrafici.comune = datiPazienteProps.comuneResidenza && datiPazienteProps.comuneResidenza.codice && this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] : this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] : ""
            datiAnagrafici.professione = professioni[datiPazienteProps.professione].descrizione
            datiAnagrafici.cittadinanza = datiPazienteProps.cittadinanza ? datiPazienteProps.cittadinanza.codice ? this.state.nazioniPerCodice[datiPazienteProps.cittadinanza.codice] : "" : ""

            this.setState({datiAnagrafici: datiAnagrafici});

        }

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDatiAnagraficiMalaria(this.state.datiAnagrafici, "", oggetto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setDatiAnagraficiMalaria(this.state.datiAnagrafici, this.validate(), res)
        }
    }

    validate() {

        if (this.state.datiAnagrafici.dataNascita) {
            let validatedataNascita = Utils.checkDateInterval(this.state.datiAnagrafici.dataNascita, "31/12/1899");
            let validatedataNascitaOdierna = Utils.checkDateInterval(this.state.datiAnagrafici.dataNascita, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataNascita) {
                return "Messages.DataNascita"
            } else if (!validatedataNascitaOdierna) {
                return "Messages.DataNascitaOdierna"
            }
        }

        return ""

    }

    controlloDati() {
        let datiAnagrafici = this.state.datiAnagrafici
        datiAnagrafici.corretto = []

        if (this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato) {
            if (!datiAnagrafici.cognome) datiAnagrafici.corretto[0] = "Campo \"Cognome\" mancante";
            if (!datiAnagrafici.nome) datiAnagrafici.corretto[1] = "Campo \"Nome\" mancante";
        }
        if (!datiAnagrafici.dataNascita || (datiAnagrafici.dataNascita && Utils.isDateInValid(Utils.transformDateForBackend(datiAnagrafici.dataNascita), "-"))) datiAnagrafici.corretto[2] = "Campo \"Data di nascita\" mancante o errato";
        if (this.props.datiPaziente && this.props.datiPaziente.soggettoAnonimizzato) {
            if (!datiAnagrafici.sesso) datiAnagrafici.corretto[3] = "Campo \"Sesso\" mancante";
        }

        this.setState({datiAnagrafici: datiAnagrafici})
    }

    createOggettoBE() {
        let datiAnagrafici = JSON.parse(JSON.stringify(this.state.datiAnagrafici))
        let datiAnagraficiBe = Utils.removeEmptyValueFromObject(datiAnagrafici)
        return Utils.removeFieldFromObject(datiAnagraficiBe, "corretto")
    }

    riceviValore(field, event) {
        let datiAnagrafici = this.state.datiAnagrafici
        if (field.currentTarget) {
            datiAnagrafici[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiAnagrafici[field] = event.target.value
        }
        this.setState({datiAnagrafici: datiAnagrafici})

        this.controlloDati()
    }

    riceviValoreRadioButton(event, field) {
        let datiAnagrafici = this.state.datiAnagrafici
        datiAnagrafici[field] = event
        this.setState({datiAnagrafici: datiAnagrafici})
        this.controlloDati()
    }

    render() {

        const {t} = this.props;

        let suggestionComuneNazione = this.state.listaComuni.concat(this.state.listaNazioni);

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    <div className="row" style={{marginTop: "5px"}}>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello5' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.cognome")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}
                            </p>
                            <Input id={"cognome"}
                                   onChange={this.riceviValore}
                                   field={"cognome"}
                                   value={this.state.datiAnagrafici.cognome}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.cognome")}/>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.nome")}
                                {this.props.datiPaziente && !this.props.datiPaziente.soggettoAnonimizzato ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : null}</p>
                            <Input id={"nome"}
                                   onChange={this.riceviValore}
                                   field={"nome"}
                                   value={this.state.datiAnagrafici.nome}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.nome")}/>
                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.dataNascita")}
                                <span className={stylesWelcome.mandatoryColor}>*</span></p>
                            <Calendar
                                id={"dataNascita"}
                                value={this.state.datiAnagrafici.dataNascita}
                                field={"dataNascita"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.dataNascita"))}
                                error={(this.state.datiAnagrafici.dataNascita === "" || this.state.datiAnagrafici.dataNascita == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagrafici.dataNascita), "-")
                                }
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-1 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.eta")}
                            </p>
                            <Input id={"eta"}
                                   type={"number"}
                                   min="0"
                                   onChange={this.riceviValore}
                                   field={"eta"}
                                   disabled={true}
                                   value={this.state.datiAnagrafici.eta}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.eta")}/>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div style={{marginRight: "20px", minWidth: "279px"}}>
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.sesso")}
                                    <span className={stylesWelcome.mandatoryColor}>*</span></p>
                                <div className="row">
                                    <RadioButton id={"sessoM"}
                                                 name={"sesso"}
                                                 label={"M"}
                                                 value={"0"}
                                                 onClick={() => this.riceviValoreRadioButton("M", "sesso")}
                                                 checked={this.state.datiAnagrafici.sesso === "M"}
                                    />

                                    <RadioButton id={"sessoF"}
                                                 name={"sesso"}
                                                 label={"F"}
                                                 value={"1"}
                                                 onClick={() => this.riceviValoreRadioButton("F", "sesso")}
                                                 checked={this.state.datiAnagrafici.sesso === "F"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div className="container">
                <div className="row" style={{marginTop: "5px"}}>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.indirizzo")}
                        </p>
                        <Input id={"indirizzo"}
                               onChange={this.riceviValore}
                               field={"indirizzo"}
                               value={this.state.datiAnagrafici.indirizzo}
                               placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.indirizzo")}/>
                    </div>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.comune")}
                        </p>
                        <div className={stylesWelcome.fieldContainer}>
                            <Autocomplete
                                id={"comune"}
                                keyField={"codice"}
                                value={this.state.datiAnagrafici.comune}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                onChange={this.riceviValore}
                                field={"comune"}
                                placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.comune")}
                                suggestions={suggestionComuneNazione}
                            />
                        </div>
                    </div>


                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.provincia")}
                        </p>
                        <div className={stylesWelcome.fieldContainer}>
                            <Autocomplete
                                id={"provincia"}
                                keyField={"codice"}
                                value={this.state.datiAnagrafici.provincia}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                onChange={this.riceviValore}
                                field={"provincia"}
                                placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.provincia")}
                                suggestions={this.state.listaProvince}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione3 = (


            <div className="container">
                <div className="row" style={{marginTop: "5px"}}>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.professione")}
                        </p>
                        <Input id={"professione"}
                               onChange={this.riceviValore}
                               field={"professione"}
                               value={this.state.datiAnagrafici.professione}
                               placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.professione")}/>
                    </div>

                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.cittadinanza")}
                        </p>
                        <div className={stylesWelcome.fieldContainer}>
                            <Autocomplete id={"cittadinanza"}
                                          value={this.state.datiAnagrafici.cittadinanza}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.riceviValore}
                                          field={"cittadinanza"}
                                          placeholder={t("SchedaFlussoSpeciale.Malaria.DatiAnagrafici.cittadinanza")}
                                          suggestions={this.state.listaNazioni}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );


        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
            </div>

        )
    }

}

export default withTranslation('common')(DatiAnagraficiMalaria)
